import type { ComponentProps, ReactNode } from "react";
import { SideBar } from "cerulean";

type SideBarPageProps = Pick<
  ComponentProps<typeof SideBar>,
  "activeStep" | "steps"
> & {
  children: ReactNode;
  institution: API.Institution;
};

const SideBarPage = ({
  children,
  activeStep,
  steps,
  institution
}: SideBarPageProps) => (
  <div className="sidebar-page-container">
    <SideBar
      activeStep={activeStep}
      steps={steps}
      logo_url={institution.logo_url}
    />
    <div className="sidebar-content-container">
      <div className="sidebar-content">{children}</div>
    </div>
  </div>
);

export default SideBarPage;
